'use client'

import * as Sentry from '@sentry/nextjs'
import { useCallback, useEffect } from 'react'

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN
const COOKIE_KEY = 'cookie_consent'
const CONSENT_CHANGED_EVENT = 'consentChanged'

declare global {
  interface Window {
    SENTRY_INITIALIZED?: boolean
  }
}

export const SentryInit: React.FC = () => {
  const updateConsentAndMaybeInit = useCallback(() => {
    if (typeof window === 'undefined') return

    const stored = window.localStorage.getItem(COOKIE_KEY)
    const hasConsent = stored === 'accepted'
    const alreadyInit = window.SENTRY_INITIALIZED

    if (hasConsent && SENTRY_DSN && !alreadyInit) {
      Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [Sentry.replayIntegration()],
        tracesSampleRate: 0.4,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 0.4,
        debug: false,
      })
      window.SENTRY_INITIALIZED = true
    }
  }, [])

  useEffect(() => {
    updateConsentAndMaybeInit()
    window.addEventListener(CONSENT_CHANGED_EVENT, updateConsentAndMaybeInit)
    return () => {
      window.removeEventListener(CONSENT_CHANGED_EVENT, updateConsentAndMaybeInit)
    }
  }, [updateConsentAndMaybeInit])

  return null
}
